import { readMdxAttributes } from "@productlane/lib/src/tiptap/extensions/mintlify/icon-html"
import { unwrapParagraph } from "@productlane/lib/src/tiptap/extensions/mintlify/layout-props"

import type { MdxBlockReader } from "./registry"

const STEP = /<Step\b([^>]*?)(?:\/>|>([\s\S]*?)<\/Step>)/g

const escapeHtml = (value: string): string =>
	value
		.replace(/&/g, "&amp;")
		.replace(/"/g, "&quot;")
		.replace(/</g, "&lt;")
		.replace(/>/g, "&gt;")

const truthy = (value: string | undefined): boolean =>
	value !== undefined && value !== "false"

// Mintlify's Steps keep our house steps list; each title leads its step in bold.
export const stepsReaders: MdxBlockReader[] = [
	{
		name: "steps",
		pattern: /<Steps\b[^>]*>([\s\S]*?)<\/Steps>/g,
		render: (match, parseBody) => {
			const items = [...(match[1] ?? "").matchAll(STEP)].map((step) => {
				const title = readMdxAttributes(step[1] ?? "").title?.trim()
				const heading = title
					? `<p><strong>${unwrapParagraph(parseBody(title))}</strong></p>`
					: ""
				const body = (step[2] ?? "").trim() ? parseBody(step[2] ?? "") : ""
				return `<li>${heading}${body}</li>`
			})
			return `<ol class="steps-list">${items.join("")}</ol>`
		},
	},
]

// An AccordionGroup has no node of its own: neighbouring accordions render joined.
export const accordionReaders: MdxBlockReader[] = [
	{
		name: "accordion",
		pattern: /<Accordion\b(?!Group)([^>]*?)(?:\/>|>([\s\S]*?)<\/Accordion>)/g,
		render: (match, parseBody) => {
			const attributes = readMdxAttributes(match[1] ?? "")
			const title = attributes.title?.trim() || "Details"
			const description = attributes.description?.trim()
			const open = truthy(attributes.defaultOpen) ? " open" : ""
			const summary = `<summary class="details-summary"${description ? ` data-description="${escapeHtml(description)}"` : ""}>${unwrapParagraph(parseBody(title))}</summary>`
			const body = (match[2] ?? "").trim()
				? parseBody(match[2] ?? "")
				: "<p></p>"
			return `<details class="details-wrapper"${open}>${summary}<div data-type="detailsContent" class="details-content">${body}</div></details>`
		},
	},
	{
		name: "accordion-group",
		pattern: /<AccordionGroup\b[^>]*>([\s\S]*?)<\/AccordionGroup>/g,
		render: (match, parseBody) => parseBody(match[1] ?? ""),
	},
]
